import { atempl } from "@api/v0/fetch/.endpoints";
import AriaAct from "@resources/aria-act/AriaAct";
import { SwiperSetup } from "@resources/swiper-setup/SwiperSetup";

document.addEventListener('DOMContentLoaded', function() {
	AriaAct.registerListener('click',`[data-explore="open"]`,'expandOpen')
	AriaAct.registerListener('click',`[data-explore="close"]`,'expandClose')
	// window.addEventListener( 'click', persistSearch, false)

	window.addEventListener("AriaAct:expandOpen", (e) => {
		if( e.detail.trigger.dataset.explore !== 'open' ) return;
		let slider = document.querySelector('.explore__slider [data-swiper-id]');
		let swiper = slider && SwiperSetup.swiperList[ slider.dataset.swiperId ]
		let holder = e.detail.targets.length && e.detail.targets[0];
		if( holder && swiper ){
			let fetchState = holder.getAttribute('atempl-status');
			fetchState && !fetchState.includes('has-filter') && swiper.autoplay.run();
		}
	});

	window.addEventListener("AriaAct:expandClose", (e) => {
		if( e.detail.trigger.dataset.explore !== 'close' ) return;
		let slider = document.querySelector('.explore__slider [data-swiper-id]');
		let swiper = slider && SwiperSetup.swiperList[ slider.dataset.swiperId ]
		swiper && swiper.autoplay.pause();
	});

	window.addEventListener('submit', (e) => {
		let target = e.target.closest('#explore-filter');
		target && e.preventDefault();
	})
});
